import {ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {BusinessRelation} from "../../../shared/view-model/crm/business-relation";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {appInjector} from "../../../index";
import {BusinessRelationsFormComponent} from "../business-relations-form/business-relations-form.component";
import {SessionActions} from "../../../shared/actions/session.actions";

@Component({
  selector: 'vb-supplier-business-relations-form',
  templateUrl: './supplier-business-relations-form.component.html',
  styleUrls: ['./supplier-business-relations-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => SupplierBusinessRelationsFormComponent)}]
})
export class SupplierBusinessRelationsFormComponent extends AbstractVisbosControl<BusinessRelation, FormGroup> implements OnChanges, OnInit {

  @Input()
  adminUnitCuid: string;

  @Input()
  supplierCuid: string;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions);
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if (changes.adminUnitCuid && !changes.adminUnitCuid.firstChange) {
      this.control.patchValue({
        relation: {
          relation_source_id: changes.adminUnitCuid.currentValue
        }
      })
    }

    if (changes.supplierCuid && !changes.supplierCuid.firstChange) {
      this.control.patchValue({
        relation: {
          relation_target_id: changes.supplierCuid.currentValue
        }
      })
    }
  }

  buildControlContent(): FormGroup {
    return SupplierBusinessRelationsFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      relation: BusinessRelationsFormComponent.initControl(fb),
      relation_data: fb.group({
        cuid: [null, Validators.required],
        customer_number: [null],
        order_kind_id: [null]
      })
    });

  }

  public setDefaultValues(item?: BusinessRelation): { [controlKey: string]: any } | any {
    let relDataCuid = this.setValue(item, 'relation_type.cuid', AbstractVisbosControl.cuid());
    return {
      relation: {
        cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
        relation_source_id: this.setValue(item, 'relation_source.cuid', this.adminUnitCuid),
        relation_source_type: this.setValue(item, 'relation_source_type', 'Standort'),
        relation_target_id: this.setValue(item, 'relation_target.cuid', this.supplierCuid),
        relation_target_type: this.setValue(item, 'relation_target_type', 'Lieferant'),
        relation_type_id: this.setValue(item, 'relation_type.cuid', relDataCuid),
        relation_type_type: this.setValue(item, 'relation_type_type', 'Lieferantenbeziehung')
      },
      relation_data: {
        cuid: relDataCuid,
        customer_number: this.setValue(item, 'relation_type.customer_number'),
        order_kind_id: this.setValue(item, 'relation_type.order_kind.cuid'),
      }
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/business-relations/supplier-business-relations-form/supplier-business-relations-form.component.ts